<template>
  <div class="card-container">
    <common-top-form
      @openAddDialog="addInfo"
      :submitService="submitService"
      :selectShow="true"
      :model="formModel"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <select-organs
        v-model="formModel.tatSimpleId"
        :needAll="false"
        :selectValue="formModel.tatSimpleId"
      ></select-organs>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="level"
        min-width="80"
        label="排位等级"
      ></el-table-column>
      <el-table-column
        prop="memLevelName"
        min-width="130"
        label="等级名称"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="profit"
        label="奖励金额"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="money"
        label="交易量(万元)"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="countMoney"
        label="实际交易量(元)"
        min-width="130"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="peopleNumber"
        label="人数"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="160"
        :formatter="formatterTableStatus"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="modifier"
        label="创建人"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="180">
        <template slot-scope="scope">
          <el-button type="text" @click="addInfo(1, scope.row)">加人</el-button>
          <el-button type="text" @click="addInfo(2, scope.row)">加钱</el-button>
          <!-- <el-button
            type="text"
            @click="Disabled(scope.row.id, scope.row.status)"
            :class="{ 'button-color': scope.row.status == 1 }"
          >
            {{ scope.row.status == 1 ? "禁用" : "启用" }}
          </el-button> -->
          <!-- <el-button
            type="text"
            @click="Delete(scope.row.id)"
            class="button-color"
            >删除
          </el-button> -->
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @success="dialogSuccess"
      @close="dialogClose"
      labelWidth="110px"
    >
      <el-form-item
        label="实际交易量(元)"
        prop="countMoney"
        v-if="this.type == 2"
      >
        <el-input
          v-model.number="money"
          maxlength="10"
          minlength="0"
          type="text"
          placeholder="请输入交易量"
        ></el-input>
      </el-form-item>
      <el-form-item label="人数" prop="peopleNumber" v-if="this.type == 1">
        <el-input
          v-model.number="dialogModel.peopleNumber"
          maxlength="10"
          minlength="0"
          type="text"
          placeholder="请输入人数"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import SelectOrgans from "components/business/SelectOrgans";

import MemberLevelService from "service/MemberLevelService";
import MarketService from "service/MarketService";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "levelpublicplatoontest",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectOrgans,
  },
  data() {
    return {
      money: "",
      formModel: {
        tatSimpleId: "",
      },
      dialogModel: {
        countMoney: "",
        peopleNumber: "",
      },
      status: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "0",
          dictValue: "禁用",
        },
        {
          dictKey: "1",
          dictValue: "启用",
        },
        {
          dictKey: "2",
          dictValue: "待启动",
        },
      ],
      formDialogTitle: "",
      submitService: MarketService.memLevelPublicPlatoonList,
      tableData: [],
      levelNameList: [],
      isPage: false,
      dialogId: "",
      type: "",
      page: {},
      dialogRules: {
        countMoney: [
          {
            required: true,
            message: "请输入金额",
          },
        ],
        peopleNumber: [
          {
            required: true,
            message: "请输入人数",
          },
        ],
      },
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  computed: {
    submitData() {
      const params = {
        pId: 0,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
        tatSimpleId: this.formModel.tatSimpleId,
      };
      return params;
    },
    dialogData() {
      const params = {
        countMoney: this.money * 100,
        number: this.dialogModel.peopleNumber,
      };
      if (this.dialogId) {
        params.id = this.dialogId;
      }
      return params;
    },
    dialogService() {
      return this.type == 1
        ? MarketService.levelPublicPeople
        : MarketService.memLevelPublicPlatoonEdit;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  mounted() {
    this.page = this.$refs.commonTable.page;
  },
  methods: {
    addInfo(type, item) {
      if (type == 2) {
        this.money = item.countMoney / 100;
      }

      if (type) {
        this.type = type;
        this.formDialogTitle = this.type == 1 ? "加人" : "加钱";
      }
      this.dialogId = "";
      if (item) {
        this.dialogId = item.id;
        this.getDetail(item);
      }
      this.dialogType = true;
      this.$refs.formDialog.open();
    },
    formatterTableStatus(row, column, cellValue, index) {
      let value = "--";
      this.status.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    formatterTableDate(row, column, cellValue, index) {
      return row.updateTime ? row.updateTime : row.createTime;
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.onSuccess(res);
          this.isPage = false;
        },
        "信息获取失败"
      );
    },
    getDetail(item) {
      this.dialogModel = JSON.parse(JSON.stringify(item));
    },
    dialogSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.showSuccess(result.optMsg);
        this.getList();
        this.$refs.formDialog.closeDialog();
      });
    },
    dialogClose() {
      this.dialogModel = {
        // 需要改 关闭清空
        countMoney: "",
        peopleNumber: "",
      };
      // alert("关闭弹框");
    },
    doDelete(id) {
      this.doLoad(
        MarketService.memLevelPublicPlatoonDel,
        {
          pId: 0,
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    Delete(id) {
      this.showConfirm(`确定删除此等级公排测试？`)
        .then(() => {
          this.doDelete(id);
        })
        .catch(() => {});
    },
    doDisabled(id, type) {
      const disabledParams = {
        id: id,
        pId: 0,
        userId: this.userId,
        status: type == 1 ? 0 : 1,
      };

      this.doLoad(
        MarketService.memLevelPublicPlatoonUdp,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    Disabled(id, type) {
      this.showConfirm(`确定${type == 1 ? "禁用" : "启用"}此等级公排测试？`)
        .then(() => {
          this.doDisabled(id, type);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.levelList {
  display: flex;
  flex-wrap: wrap;
}

.unit {
  margin-left: 10px;
  color: #aaaaaa;
  word-break: keep-all;
}
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/LevelPublicPlatoonTest.vue